<template>
    <v-row>
        <v-col class="py-0 px-2" cols="12">
            <v-data-table
                dense
                :headers="headers"
                :items="list"
                :page.sync="page"
                :items-per-page="10"
                @page-count="pageCount = parseInt($event, 10)"
                hide-default-footer
            >
                <template v-slot:item="props">
                    <tr>
                        <td>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <span v-bind="attrs" v-on="on" class="pr-2">
                                        <v-icon :color="colorList[props.item.status]" small>
                                            {{iconList[props.item.status] }}
                                        </v-icon>
                                    </span>
                                </template>
                                <span class="px-3 py-1 ma-0" style=" border: solid 1px #999; border-radius: 5px; background-color: #fff;">
                                    {{ labelList[props.item.status] }}
                                </span>
                            </v-tooltip>
                            {{ props.item.data_evento | formatDateHour }}
                        </td>
                        <td>
                            {{ props.item.identificador_prestador }}
                        </td>
                        <td>
                            <span v-if="!props.item.erro"> {{ props.item.descricao ? props.item.descricao : ''}} </span>
                            <span v-else style="color: #d0021b"> {{ props.item.descricao }} </span>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-col>
        <v-col class="pa-0" cols="12">
            <v-pagination class="no-box-shadow" v-model="page" :length="pageCount"></v-pagination>
        </v-col>
    </v-row>
</template>

<script>
import moment from "moment"
export default {
    props: {
        list: Array
    },
    data() {
        return {
            headers: [
                { text: "Data do evento", value: "data_evento", sortable: false },
                { text: "Ident.", value: "identificador_prestador", sortable: false },
                { text: "Evento", value: "evento", sortable: false },
            ],
            colorList:{
                executado: "success", 
                em_execucao: "warning",
                com_intercorrencia: "error"
                },
            iconList:{
                executado: "fa-check-circle", 
                em_execucao: "fas fa-exclamation-triangle",
                com_intercorrencia: "fas fa-exclamation-circle"
            },
            labelList:{
                executado: "Executado", 
                em_execucao: "Em execução",
                com_intercorrencia: "Com intercorrência"
            },
            page: 1,
            pageCount: 1
        }
    },
    filters: {
        formatDateHour(date) {
            return moment(date).format('L') + ' às ' + moment(date).format('LT') + 'h' 
        },
    }
} 
</script>

<style>

</style>